import { createAction, props } from '@ngrx/store';
import { ExpressPassState } from './express-pass.state';

export const setExpressData = createAction('expresspassdata', props<{ value: ExpressPassState }>());
